<template>
    <apexchart
        width="100%"
        type="radialBar"
        :options="parseOptions"
        :series="[value]"
    ></apexchart>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    components: {
        apexchart: VueApexCharts,
    },

    props: {
        value: {
            required: true,
        },
        colors: {
            type: Array,
            default: () => ['#f44336', '#1976d2', '#4caf50'],
        },
    },

    data: () => {
        return {
            chartOptions: {
                chart: {
                    offsetY: -20,
                    sparkline: {
                        enabled: true,
                    },
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            background: '#e7e7e7',
                            strokeWidth: '97%',
                            margin: 5, // margin is in pixels
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                offsetY: -2,
                                fontSize: '22px',
                            },
                        },
                    },
                },
                grid: {
                    padding: {
                        top: -10,
                    },
                },
                fill: {
                    colors: ['#1976d2'],
                },
            },
        }
    },

    computed: {
        getColor() {
            let colorIndex = Math.floor(this.value / (100 / this.colors.length))

            if (colorIndex >= this.colors.length) {
                colorIndex = this.colors.length - 1
            }

            return [this.colors[colorIndex]]
        },

        parseOptions() {
            let parsed = this.chartOptions

            parsed.fill.colors = this.getColor

            return parsed
        },
    },
}
</script>

<style></style>
